import { z } from "zod";

const EnvSchema = z.object({
  VITE_API_URL: z.string().url({ message: "VITE_API_URL must be a valid URL" }),
});

export type FrontendEnv = z.infer<typeof EnvSchema>;

export class FrontendEnvValidationError extends Error {
  constructor(issues: z.ZodIssue[]) {
    const formatted = issues.map((i) => `  - ${i.path.join(".") || "(root)"}: ${i.message}`).join("\n");
    super(`Frontend environment is invalid:\n${formatted}`);
    this.name = "FrontendEnvValidationError";
  }
}

export function parseFrontendEnv(raw: Record<string, string | undefined>): FrontendEnv {
  const result = EnvSchema.safeParse(raw);
  if (!result.success) {
    throw new FrontendEnvValidationError(result.error.issues);
  }
  return result.data;
}

let cached: FrontendEnv | null = null;

export function getEnv(): FrontendEnv {
  if (cached) return cached;
  const source = typeof import.meta !== "undefined" && import.meta.env
    ? (import.meta.env as Record<string, string | undefined>)
    : (process.env as Record<string, string | undefined>);
  cached = parseFrontendEnv(source);
  return cached;
}
